/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/12/email': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g _fill="#444"><path pid="0" d="M10 6.136V9H2V6.136L0 4.8V10a1 1 0 001 1h10a1 1 0 001-1V4.8z" data-color="color-2"/><path pid="1" d="M12 3L6 7 0 3V2a1 1 0 011-1h10a1 1 0 011 1z"/></g>'
  }
})
